import React, { useEffect, useState,useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  Box,
  Paper,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { fetchWeeklySignUpTrend } from "../../../api/nystats";
import { useSelector } from "react-redux";
import moment from "moment";

export default function WeeklySignUpTrend() {
  // get always current week and year
  const [week, setWeek] = useState(moment().isoWeek());
  const [year, setYear] = useState(moment().isoWeekYear());

  const [main, setMain] = useState([]);
  const [prev, setPrev] = useState([]);
  const filter = useSelector((state) => state.filter);
  const [isLoading, setIsLoading] = useState(true);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);

    const fetchData =async()=>{
      try {
        setIsLoading(true)
        const { current, previous } = await fetchWeeklySignUpTrend({ ...filter, week, year });
        setMain(current);
        setPrev(previous);
      } catch (error) {
        setMain([]);
        setPrev([]);
      }
      setIsLoading(false)
    }

  useEffect(() => {
    fetchData()
  }, [week, year, JSON.stringify(filterWithoutUTM)]);

  const weekOptions = Array.from({ length: 52 }).map((_, i) => ({
    label: `Week ${i + 1}`,
    value: i + 1,
  }));

  const yearOptions = [2023, 2024, 2025];

  const cats = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const options = {
    chart: { type: "line", height: 400 },
    xAxis: { categories: cats },
    title: { text: null },
    yAxis: {
      title: {
        text: "Users",
        style: {
          fontSize: "12px",
          fontWeight: "600",
          color: "#000",
        }
      }
    },

    series: [
      { name: "Current", data: main, color: "#1F7B5D" },
      { name: "Previous", data: prev, dashStyle: "ShortDash", color: "#C4C4C4" },
    ],
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "10px",
            fontWeight: "500",
            textOutline: "none",
            background: '#000',
          }
        }
      }
    },
    credits: { enabled: false },
  };

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "12px",
        boxShadow: "none",
        border: "1px solid #E8E8E8",
        background: "#fff",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography fontSize={18} fontWeight={600}>
          Weekly Sign-Up Trend
        </Typography>

        {/* ================== Autocomplete Inputs ================== */}
        {(prev?.length || !main?.length) && <Box display="flex" gap={2}>
          {/* Week Autocomplete */}
          <Autocomplete
            options={weekOptions}
            value={weekOptions.find((w) => w.value === week)}
            onChange={(e, newValue) => setWeek(newValue?.value || 1)}
            sx={{ width: 150 }}
            popupIcon={<KeyboardArrowDownIcon />}
            renderInput={(params) => <TextField {...params} label="Week" />}
          />

          {/* Year Autocomplete */}
          <Autocomplete
            options={yearOptions}
            value={year}
            onChange={(e, newValue) => setYear(newValue)}
            sx={{ width: 150 }}
            popupIcon={<KeyboardArrowDownIcon />}
            renderInput={(params) => <TextField {...params} label="Year" />}
          />
        </Box>}
      </Box>

      {
        isLoading ? <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> : <>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </>
      }

    </Paper>
  );
}
